/**
 * makes a Promise suspense friendly by throwing if the value hasn't been
 * resolved yet.
 */
function withSuspenseCache(value) {
  if (value instanceof Promise) {
    throw value;
  }
  return value;
}

export { withSuspenseCache };
//# sourceMappingURL=util.with-suspense-cache.js.map
